// extracted by mini-css-extract-plugin
export default {"wrapper":"ApartmentBadge_wrapper__JSbvH"};